/**
 * Generates a string to be read as accessibility label
 *
 * @param {Object} params - Parameters
 * @param {string} params - The title of the tab
 * @param {string} params - The name of the open screen
 * @param {number} params - The index number of the tab
 * @param {number} params - The total number of tabs
 *
 * @returns {string} - A string to be used for tab accessibility label
 */

export const getAccessibilityLabel = ({
  name,
  currentScreen,
  index,
  totalTabs,
}: any) => {
  const selectedText = currentScreen === name ? 'selected, ' : '';
  return `${name}, ${selectedText}${index + 1} of ${totalTabs}`;
};
